import React, { useEffect, useState } from 'react';
import { Container, Typography, Card, CardContent, Box } from '@mui/material';
import bibtexParse from 'bibtex-parse-js';
import { formatAuthors } from '../utils';

function Award() {
    const [awards, setAwards] = useState([]);

    useEffect(() => {
        fetch(`${process.env.PUBLIC_URL}/awards.bib`)
            .then((response) => response.text())
            .then((data) => {
                const parsed = bibtexParse.toJSON(data);
                setAwards(parsed);
            })
            .catch((error) => console.error('Error loading BibTeX file:', error));
    }, []);

    return (
        <Container>
            {awards.map((award, index) => (
                <Card
                    key={index}
                    variant="outlined"
                    sx={{
                        marginBottom: '20px',
                        display: 'flex',
                        alignItems: 'flex-start',
                        padding: '10px',
                    }}
                >
                    {/* 左側の情報 */}
                    <CardContent sx={{ flex: 1 }}>
                        <Typography variant="body1" sx={{ fontWeight: 'bold', marginBottom: '5px' }}>
                            {award.entryTags.title}
                        </Typography>
                        <Typography variant="body2" color="textSecondary" sx={{ marginBottom: '5px' }}>
                            {formatAuthors(award.entryTags.author)}
                        </Typography>
                        <Typography variant="body2" color="textSecondary" sx={{ marginBottom: '5px' }}>
                            {award.entryTags.event}, {award.entryTags.year}
                        </Typography>
                        {award.entryTags.note && (
                            <Typography variant="body2" color="textSecondary">
                                {award.entryTags.note}
                            </Typography>
                        )}
                    </CardContent>
                </Card>
            ))}
        </Container>
    );
}

export default Award;
